export default "__VITE_ASSET__f9283a82__"